export const isEmpty = (v: unknown): boolean => !v || !String(v).trim();

export const isDni = (v: unknown): boolean =>
  /^\d{7,9}$/.test(String(v ?? "").trim());

export const isEmail = (v: unknown): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v ?? "").trim());

export const isYear = (v: unknown): boolean => {
  const str = String(v ?? "").trim();
  if (!/^\d{4}$/.test(str)) return false;
  const n = Number(str);
  const max = new Date().getFullYear();
  return n >= 1990 && n <= max;
};
